import { render } from "./UserEarning.vue?vue&type=template&id=0128a7f8&scoped=true"
import script from "./UserEarning.vue?vue&type=script&lang=js"
export * from "./UserEarning.vue?vue&type=script&lang=js"

import "./UserEarning.vue?vue&type=style&index=0&id=0128a7f8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0128a7f8"

export default script